<template>
  <div class="container__progress-line" :class="direction">
    <simple-svg
      :src="require(`@/assets/progressIcon.svg`)"
      width="9px"
      height="12px"
    />
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressLine',
  props: {
    direction: {
      type: String,
      default: 'horizontal',
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  &__progress-line.horizontal {
    display: flex;
    align-items: center;
    width: 100%;

    .line {
      width: 100%;
      height: 1px;
      border-top: 1px dashed #f44336;
    }
  }

  &__progress-line.vertical {
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 9;
    height: 100%;

    .line {
      width: 1px;
      height: 100%;
      border-left: 1px solid #f44336;
      margin-top: -2px;
    }
  }
}
</style>

<style>
.container__progress-line.vertical svg {
  transform: rotate(90deg) translateY(4px);
}
</style>
